import { render, staticRenderFns } from "./ProductInfoPage.vue?vue&type=template&id=0ef76608&scoped=true&"
import script from "./ProductInfoPage.vue?vue&type=script&lang=js&"
export * from "./ProductInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoPage.vue?vue&type=style&index=0&id=0ef76608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef76608",
  null
  
)

export default component.exports